import React from 'react'
import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import CaptionField from '../../../../../form-fields/super-cut/caption-file'

const Caption = styled(CaptionField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoCaptionField = ({ field }: Props) => {
    return (
        <Caption
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoCaptionField
